var exports = {
  "ij": "xaf9ae18d--5bd177--promo-balloon",
  "z0": "xaf9ae18d--5bd177--promo-balloon--redesign",
  "$Y": "xaf9ae18d--5bd177--promo-balloon--hovered",
  "Kk": "xaf9ae18d--5bd177--icon",
  "U9": "xaf9ae18d--5bd177--count",
  "gm": "xaf9ae18d--5bd177--promo-balloon--redesign-v2",
  "q9": "xaf9ae18d--5bd177--price",
  "Qs": "xaf9ae18d--5bd177--content",
  "zH": "xaf9ae18d--5bd177--details",
  "vu": "xaf9ae18d--5bd177--active",
  "DV": "xaf9ae18d--5bd177--counter-wrapper",
  "KF": "xaf9ae18d--5bd177--promotion",
  "lq": "xaf9ae18d--5bd177--viewed",
  "MP": "xaf9ae18d--5bd177--residential-complex",
  "ck": "xaf9ae18d--5bd177--colorized",
  "hJ": "xaf9ae18d--5bd177--counter",
  "eH": "xaf9ae18d--5bd177--promo-wrapper",
  "nC": "xaf9ae18d--5bd177--promo-wrapper--redesign",
  "_T": "xaf9ae18d--5bd177--promo-wrapper--cluster",
  "h6": "xaf9ae18d--5bd177--promo-wrapper-details",
  "ej": "xaf9ae18d--5bd177--promo-wrapper--redesign-v2",
  "nG": "xaf9ae18d--5bd177--promo-point",
  "Lo": "xaf9ae18d--5bd177--content--redesign",
  "Pf": "xaf9ae18d--5bd177--label",
};

module.exports = exports;
